var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3DAE0",
    d: "M34.15 23.395v-8.389C34.15 6.718 27.59 0 19.5 0 11.41 0 4.85 6.718 4.85 15.006v8.389m5.283 0v-8.389c0-5.291 4.202-9.595 9.367-9.595 5.165 0 9.367 4.304 9.367 9.595v8.389",
    transform: "translate(-685.000000, -280.000000) translate(430.000000, 248.000000) translate(255.000000, 32.000000) translate(16.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#899EA8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.505.026C15.223.01 14.938 0 14.651 0 6.559 0 0 6.718 0 15.006v8.389h1.71v-8.389C1.71 7.012 7.811.48 15.504.026zM16.36 5.411c-.288 0-.573.014-.855.04 4.766.444 8.513 4.559 8.513 9.555v8.389h1.709v-8.389c0-5.291-4.202-9.595-9.367-9.595z",
    transform: "translate(-685.000000, -280.000000) translate(430.000000, 248.000000) translate(255.000000, 32.000000) translate(16.000000, 9.000000) translate(4.849405, 0.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F00",
    d: "M0 23.395H39V52H0z",
    transform: "translate(-685.000000, -280.000000) translate(430.000000, 248.000000) translate(255.000000, 32.000000) translate(16.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E48900",
    d: "M0 23.395H3.418V52H0z",
    transform: "translate(-685.000000, -280.000000) translate(430.000000, 248.000000) translate(255.000000, 32.000000) translate(16.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E3D4C",
    d: "M23.695 35.012c0-2.373-1.878-4.297-4.195-4.297s-4.195 1.924-4.195 4.297c0 1.635.89 3.056 2.203 3.782l-.675 5.29h5.334l-.675-5.29c1.312-.726 2.203-2.147 2.203-3.782z",
    transform: "translate(-685.000000, -280.000000) translate(430.000000, 248.000000) translate(255.000000, 32.000000) translate(16.000000, 9.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a31b813f.svg";
export { ForwardRef as ReactComponent };